import React from 'react'
import { StyledButton } from './styles'
import CircularProgress from '@mui/material/CircularProgress';
const Button = ({text,isLoading=false,disabled,variantStyle="primary",className,iconcomponent:IconComponent,...restButtonProps}) => {
  return (
    <StyledButton className={`tma_app_btn ${className}`} disabled={isLoading || disabled} variantstyle={variantStyle} {...restButtonProps}>
       {
        isLoading ? <CircularProgress className='tma_btn_spinner' color='#fff' />:<span className='tma_btn_text'>{text}</span>
       }
       {IconComponent && <span className='tma_btn_custom_icon'><IconComponent /></span>}
    </StyledButton>
  )
}

export default Button